<template>
  <div>
    <el-button @click="dialogVisiblePrint = !dialogVisiblePrint">打印预览</el-button>
    <el-button v-print="print">打印</el-button>
    <!-- 隐藏到屏幕外 -->
    <!-- <div style="position: fixed;left: 10vw;top: -10vh; background:#fff"> -->
    <div style="position: fixed;left: 110vw;top: 110vh;">
      <div id="print_area">
        <!-- 1--企业情况调查表 -->
        <Table1 v-if="printType=='1'" :printData="printData" />
        <!-- 2--安全评价风险分析表 -->
        <Table2 v-if="printType=='2'" :printData="printData" />
        <!-- 3--安全评价项目组任命书 -->
        <Table3 v-if="printType=='3'" :printData="printData" />
        <!-- 4--安全评价工作计划 -->
        <Table4 v-if="printType=='4'" :printData="printData" />
        <!-- 5--现场勘察记录 -->
        <Table5 v-if="printType=='5'" :printData="printData" />
        <!-- 6--整改通知单 -->
        <Table6 v-if="printType=='6'" :printData="printData" />
        <!-- 7--整改复查记录表 -->
        <Table7 v-if="printType=='7'" :printData="printData" />
        <!-- 8--项目内部审核表 -->
        <Table8 v-if="printType=='8'" :printData="printData" />
        <!-- 9--技术负责人审核表 -->
        <Table9 v-if="printType=='9'" :printData="printData" />
        <!-- 10--过程控制负责人审核表 -->
        <Table10 v-if="printType=='10'" :printData="printData" />
        <!-- 11--顾客满意度调查表 -->
        <Table11 v-if="printType=='11'" :printData="printData" />
        <!-- 12--质量事故投诉记录 -->
        <Table12 v-if="printType=='12'" :printData="printData" />
        <!-- 13--项目网上公示记录 -->
        <Table13 v-if="printType=='13'" :printData="printData" />
        <!-- 14--委托方提供材料清单 -->
        <Table14 v-if="printType=='14'" :printData="printData" />
        <!-- 15--项目档案存档登记表 -->
        <Table15 v-if="printType=='15'" :printData="printData" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import Table1 from './Table1'
import Table2 from './Table2'
import Table3 from './Table3'
import Table4 from './Table4'
import Table5 from './Table5'
import Table6 from './Table6'
import Table7 from './Table7'
import Table8 from './Table8'
import Table9 from './Table9'
import Table10 from './Table10'
import Table11 from './Table11'
import Table12 from './Table12'
import Table13 from './Table13'
import Table14 from './Table14'
import Table15 from './Table15'
export default {
  data() {
    return {
      // 评价类别
      pjTypeList: [
        {
          id: '1',
          label: '预评价',
        },
        {
          id: '2',
          label: '验收评价',
        },
        {
          id: '3',
          label: '现状评价',
        },
        {
          id: '4',
          label: '专项评价',
        },
        {
          id: '5',
          label: '其它',
        },
      ],
      print: {
        id: 'print_area',
        popTitle: '企业情况调查表', // 打印配置页上方的标题
        // extraHead: '打印', // 最上方的头部文字，附加在head标签上的额外标签，使用逗号分割
        preview: true, // 是否启动预览模式，默认是false
        // previewTitle: '预览的标题', // 打印预览的标题
        // previewPrintBtnLabel: '预览结束，开始打印', // 打印预览的标题下方的按钮文本，点击可进入打印
        zIndex: 20002, // 预览窗口的z-index，默认是20002，最好比默认值更高
        previewBeforeOpenCallback() {
          console.log('正在加载预览窗口！')
        }, // 预览窗口打开之前的callback
        previewOpenCallback() {
          console.log('已经加载完预览窗口，预览打开了！')
        }, // 预览窗口打开时的callback
        beforeOpenCallback() {
          console.log('开始打印之前！')
        }, // 开始打印之前的callback
        openCallback() {
          console.log('执行打印了！')
        }, // 调用打印时的callback
        closeCallback() {
          console.log('关闭了打印工具！')
        }, // 关闭打印的callback(无法区分确认or取消)
        clickMounted() {
          console.log('点击v-print绑定的按钮了！')
        },
        // url: 'http://localhost:8080/', // 打印指定的URL，确保同源策略相同
        // asyncUrl (reslove) {
        //   setTimeout(() => {
        //     reslove('http://localhost:8080/')
        //   }, 2000)
        // },
        standard: '',
        extarCss: '',
      },
      dialogVisiblePrint: false,
    }
  },
  components: {
    Table1,
    Table2,
    Table3,
    Table4,
    Table5,
    Table6,
    Table7,
    Table8,
    Table9,
    Table10,
    Table11,
    Table12,
    Table13,
    Table14,
    Table15,
  },
  methods: {
    handleClosePrint() {
      this.dialogVisiblePrint = false
    },
    handleClosedPrint() {},
  },
  computed: {
    ...mapState('process/projectTable', ['printData', 'printType']),
  },
  watch: {},
  mounted() {},
  async created() {},
}
</script>
<style lang="less" scoped>
@import url(./printDialog.scss);
</style>